// extracted by mini-css-extract-plugin
export default {"player-wrapper":"style_player-wrapper__au4+K","react-player":"style_react-player__WGjBJ"};